/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';
import type { MarketingDomainAuditRowData } from './MarketingDomainAuditRowData';
import {
    MarketingDomainAuditRowDataFromJSON,
    MarketingDomainAuditRowDataFromJSONTyped,
    MarketingDomainAuditRowDataToJSON,
    MarketingDomainAuditRowDataToJSONTyped,
} from './MarketingDomainAuditRowData';

/**
 * 
 * @export
 * @interface MarketingDomainAuditData
 */
export interface MarketingDomainAuditData {
    /**
     * 
     * @type {number}
     * @memberof MarketingDomainAuditData
     */
    campaignsWithoutDomain?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketingDomainAuditData
     */
    adsWithoutDomain?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketingDomainAuditData
     */
    campaignsOnDisabledDomains?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketingDomainAuditData
     */
    adsOnDisabledDomains?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof MarketingDomainAuditData
     */
    spendWithoutDomain?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof MarketingDomainAuditData
     */
    spendOnDisabledDomains?: MoneyOutput;
    /**
     * 
     * @type {Array<MarketingDomainAuditRowData>}
     * @memberof MarketingDomainAuditData
     */
    rows?: Array<MarketingDomainAuditRowData>;
}

/**
 * Check if a given object implements the MarketingDomainAuditData interface.
 */
export function instanceOfMarketingDomainAuditData(value: object): value is MarketingDomainAuditData {
    return true;
}

export function MarketingDomainAuditDataFromJSON(json: any): MarketingDomainAuditData {
    return MarketingDomainAuditDataFromJSONTyped(json, false);
}

export function MarketingDomainAuditDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketingDomainAuditData {
    if (json == null) {
        return json;
    }
    return {
        
        'campaignsWithoutDomain': json['campaignsWithoutDomain'] == null ? undefined : json['campaignsWithoutDomain'],
        'adsWithoutDomain': json['adsWithoutDomain'] == null ? undefined : json['adsWithoutDomain'],
        'campaignsOnDisabledDomains': json['campaignsOnDisabledDomains'] == null ? undefined : json['campaignsOnDisabledDomains'],
        'adsOnDisabledDomains': json['adsOnDisabledDomains'] == null ? undefined : json['adsOnDisabledDomains'],
        'spendWithoutDomain': json['spendWithoutDomain'] == null ? undefined : MoneyOutputFromJSON(json['spendWithoutDomain']),
        'spendOnDisabledDomains': json['spendOnDisabledDomains'] == null ? undefined : MoneyOutputFromJSON(json['spendOnDisabledDomains']),
        'rows': json['rows'] == null ? undefined : ((json['rows'] as Array<any>).map(MarketingDomainAuditRowDataFromJSON)),
    };
}

export function MarketingDomainAuditDataToJSON(json: any): MarketingDomainAuditData {
    return MarketingDomainAuditDataToJSONTyped(json, false);
}

export function MarketingDomainAuditDataToJSONTyped(value?: MarketingDomainAuditData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'campaignsWithoutDomain': value['campaignsWithoutDomain'],
        'adsWithoutDomain': value['adsWithoutDomain'],
        'campaignsOnDisabledDomains': value['campaignsOnDisabledDomains'],
        'adsOnDisabledDomains': value['adsOnDisabledDomains'],
        'spendWithoutDomain': MoneyOutputToJSON(value['spendWithoutDomain']),
        'spendOnDisabledDomains': MoneyOutputToJSON(value['spendOnDisabledDomains']),
        'rows': value['rows'] == null ? undefined : ((value['rows'] as Array<any>).map(MarketingDomainAuditRowDataToJSON)),
    };
}

